<template>
	<div class="product-center-section">
		<div class="scroll-section1">
			<img src="images/product-center-scroll-section3-mobile-01.jpg" alt="">
		</div>
		<div class="scroll-section2">
			<div href="#anchorPoint1" :class="{item: true, active: type == 1}" v-on:click="typeChangeFun(1, 'anchorPoint1')">医疗服务</div>
			<div href="#anchorPoint2" :class="{item: true, active: type == 2}" v-on:click="typeChangeFun(2, 'anchorPoint2')">护理服务</div>
			<div href="#anchorPoint3" :class="{item: true, active: type == 3}" v-on:click="typeChangeFun(3, 'anchorPoint3')">康复服务</div>
			<div href="#anchorPoint4" :class="{item: true, active: type == 4}" v-on:click="typeChangeFun(4, 'anchorPoint4')">养老服务</div>
			<div href="#anchorPoint5" :class="{item: true, active: type == 5}" v-on:click="typeChangeFun(5, 'anchorPoint5')">护理服务托管 </div>
			<div href="#anchorPoint6" :class="{item: true, active: type == 6}" v-on:click="typeChangeFun(6, 'anchorPoint6')">职业技能培训</div>
		</div>
		<template v-for="(item,index) in list">
			<div :id="'anchorPoint' + (index+1)"></div>
			<div class="scroll-section3">
				<h1 v-html="item.h1"></h1>
				<h3 v-if="item.h3">{{item.h3}}</h3>
				<template v-for="(cItem,cIndex) in item.h2">
					<h2>
						<span></span>
						<span>{{cItem.title}}</span>
					</h2>
					<p>{{cItem.count}}</p>
				</template>
				<template v-for="(cItem,cIndex) in item.imgView">
					<div class="img-view">
						<img :src="ccItem" alt="" v-for="(ccItem,ccIndex) in cItem">
					</div>
				</template>
			</div>
		</template>
	</div>
</template>

<script>
	export default{
		name: "ProductCenterPC",
		data(){
			return {
				type: 1,
				list:[
					{
						h1: "<span style='color: #4788F4;font-size:28px;line-height: 100%;'>医</span>疗服务",
						h2: [{
							title: "陪诊代配药",
							count: "为广大患者提供的个性化的就医服务，由专业的陪诊人员为患者就医提供就诊当日全程陪同，协助办理取号、缴费，协助就诊、检查、取药以及后续疾病跟踪咨询等一站式服务。"
						},{
							title: "首诊服务",
							count: "为了方便就医，减少就诊等待的时间，更好的享受医疗资源，联合各大医院及院内医生为便捷会员就医而设立的“就医绿色通道”服务，享受优先就诊预约、优先专家预约、优先安排住院、优先安排手术等服务。"
						},{
							title: "在线复诊",
							count: "基于互联网的音视频、IM技术手段，实现患者的在线复诊，开具处方，解决患者排队难，专家挂号难，多次复诊不方便、工作繁忙抽不出时间，难以顾及行动不便患者的痛点。"
						}],
						imgView:[
							["images/product-center-scroll-section3-pc-01.png"]
						]
					},
					{
						h1: "<span style='color: #4788F4;font-size:28px;line-height: 100%;'>护</span>理服务",
						h2: [{
							title: "在院照护",
							count: "适用于处于术前及术后短期护理需求的住院期护理，具有一定自理能力或无自理能力的照护对象。"
						},{
							title: "母婴护理",
							count: "满足产褥期（顺/刨）产妇，小产（流产）女性，特体产妇（三高、高危龄）及医学许可范围内可生育但需要特殊护理产妇的日常生活及专业照护和新生儿的日常护理。孕妇的生道理和心理保健、营养餐搭配制作、孕期心理疏导和产前陪护，专产妇的月子营养餐搭配制作、产褥期的护理、保健和心理疏导、产妇形体的恢复、母乳喂养的指属导，新生儿的早期潜能开发、保健与护理等等。"
						},{
							title: "居家照护",
							count: "居家上门服务，主要包括日间护理或居家全天看护服务，护理项目包含：入浴辅助、进食辅助、变换体位、移动/移乘辅助、起床/就寝辅助、排泄辅助、更衣辅助、擦身辅助、打扫整理环境、清洗衣物、其他生活照护。"
						}],
						imgView:[
							["images/product-center-scroll-section4-pc-01.png"]
						]
					},
					{
						h1: "<span style='color: #4788F4;font-size:28px;line-height: 100%;'>康</span>复服务",
						h2: [{
							title: "在院/居家康复护理包",
							count: "根据患者的功能障碍情况，照护师通过日常生活能力的训练，肌力增强训练和耐力训练等训练，配以相应的器械，达到身体机能恢复，生活自理，生存质量的提高。"
						},{
							title: "术后康复",
							count: "预防并发症，恢复手术器官的功能，增强免疫力，使患者适应新的生活条件和与他人互动，以及心理支持。"
						}],
						imgView:[
							["images/product-center-scroll-section5-pc-01.png"]
						]
					},
					{
						h1: "<span style='color: #4788F4;font-size:28px;line-height: 100%;'>养</span>老服务",
						h2: [{
							title: "社区/居家养老",
							count: "依托社区养老服务资源，为60周岁及以上有生活照料需求的居家老年人提供或协助提供生活护理、助餐、助浴、助洁、洗涤、助行、代办、康复辅助、相谈、助医等服务。"
						}],
						imgView:[
							["images/product-center-scroll-section6-pc-01.jpg"]
						]
					},
					{
						h1: "护理服务<span style='color: #4788F4;font-size:28px;line-height: 100%;'>托</span>管",
						h2: [{
							title: "托管内容",
							count: "整体托管综合性医院、康复医院、护理院、整形医院的护工管理、培训业务，为住院病人提供住院期间的生活照护服务。"
						},{
							title: "服务支持",
							count: "服务管理，护工管理，技能培训，平台支持。"
						},{
							title: "服务机构",
							count: "综合性医院、康复医院、护理院、整形医院。"
						}],
						imgView:[
							["images/product-center-scroll-section7-pc-01.png"]
						]
					},
					{
						h1: "职业技能<span style='color: #4788F4;font-size:28px;line-height: 100%;'>培</span>训",
						h2: [{
							title: "职业资格证书培训",
							count: "养老护理证、健康照护证、母婴护理证、育婴证。"
						},{
							title: "在线技能培训",
							count: "基础素养、技能提升、护理技巧、岗前培训。"
						}],
						imgView:[
							["images/product-center-scroll-section8-pc-01.png"]
						]
					}
				]
			}
		},
		methods:{
			typeChangeFun (value, domeId){
				this.type = value;
				var scrollTop = document.getElementById(domeId).offsetTop;
				util.scrollTo(scrollTop);
			}
		}
	}
</script>

<style scoped="scoped">
	.scroll-section1 {
		width: 100%;
	}
	.scroll-section1>img {
		width: 100%;
		display: block;
	}
	.scroll-section2{
		width: 100%;
		height: 32px;
		background: #F4F4F4;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		overflow: auto;
	}
	.scroll-section2>.item{
		flex-shrink: 0;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		font-family:Microsoft YaHei;
		font-weight:400;
		line-height:1.5;
		color: #333333;
		text-decoration: none;
		border-bottom: 2px solid transparent;
		box-sizing: border-box;
		cursor: pointer;
		padding: 0 16px;
	}
	.scroll-section2>.item.active{
		font-weight: bold;
	}
	.scroll-section3{
		width: 100%;
		padding: 0 16px;
		margin-top: 54px;
		box-sizing: border-box;
		position: relative;
	}
	.scroll-section3>h1{
		font-size: 24px;
		font-family:YouSheBiaoTiHei;
		font-weight:400;
		line-height:1.3;
		color:#333333;
		padding-bottom: 4px;
		box-sizing: border-box;
	}
	
	/* .scroll-section3>h3{
		font-size: 16px;
		font-family:Microsoft YaHei;
		font-weight:400;
		line-height:1.3;
		color:#666666;
		margin: 20px auto auto auto;
	} */
	.scroll-section3>h2{
		display: flex;
		align-items: center;
		margin: 0.3rem auto auto auto;
	}
	.scroll-section3>h2>span:nth-of-type(1){
		width:4px;
		height: 16px;
		flex-shrink: 0;
		background: #4788F4;
		margin-right: 8px;
	}
	.scroll-section3>h2>span:nth-of-type(2){
		font-size: 16px;
		font-family:Microsoft YaHei;
		font-weight:bold;
		line-height:1.3;
		color: #666666;
	}
	.scroll-section3>p{
		font-size: 14px;
		font-family:Microsoft YaHei;
		font-weight:400;
		line-height:1.6;
		color: #666666;
		margin: 10px auto auto auto;
	}
	.scroll-section3>.img-view{
		margin-top: 20px;
	}
	.scroll-section3>.img-view>img{
		width: 100%;
		display: block;
	}	
</style>